import { useCallback } from 'react';
import { useUserSettings } from '@/context/UserSettingsContext';
import { formatDateTimeInTimeZone } from '@/utils';

/**
 * Hook for formatting date-time values using the user's configured timezone
 *
 * @returns {(date: Date | string | null) => string}
 */

export const useDateFormatter = () => {
    const { timezone } = useUserSettings();

    return useCallback(
        (date: Date | string | null): string => formatDateTimeInTimeZone(date, timezone),
        [timezone]
    );
};
